'use strict'

export let norwegian={
  general: {
    approach: "Tilnærming",
    controls: "Prosjektkontroll",
    lesson: "Erfaring",
    stage: "Etappe",
    statement: {
      effect: "effekt",
      because: "fordi",
      event: "hendelse",
      thisWasCausedBy: "Dette var forårsaket av",
      cause: "årsak"
    },
    hours: "Timer",
    expences: "Utgifter",
    investment: "Investeringer",
    total: "Totalt",
    stageMenu: {
      stageActions: "Etappehandlinger",
      back: "Tilbake",
      move: "Flytt",
      edit: "Endre",
      selectPhase: "Velg fase",
      noPhase: "ingen fase",
      cancelMove: "Avbryt flytting",
      requestApproval: "Forespør godkjenning",
      approveStage: "Godkjenn etappe",
      retractRequest: "Trekk tilbake forespørsel om godkjenning",
      endStageReport: "Opprett etapperapport",
      raiseException: "Håndter unntak",
      registerActuals: "Angi faktiske verdier",
      prepareClosure: "Forbered prosjektavslutning",
      changesToApprovedStage: "Du har utført endringer til en allrede godkjent etappeplan. Endringene vil automatisk bli lagret som en ny versjon når en unntaksplan blir godkjent."
    },
    stagePlan: {
      title: "Etappeplan",
      budget: "Budsjett",
      schedule: "Tidsplan",
      startDate: "Startdato",
      endDate: "Sluttdato",
      timeTolerance: "Toleranse",
      projectPhase: "Prosjekt",
      totalPhase: "Totalt for prosjektet",
      totalStagePrefix: "Totalt for ",
      actions: {
        confirmDelete: "Vil du slette denne etappen?"
      }
    },
    lessons: {
      onlyProject: "Vis bare erfaringer brukt i dette prosjektet",
      source: "Kilde",
      appliedIn: "Tatt i bruk av",
      actions: {
        applyLesson: "Bruk erfaringen",
        unapplyLesson: "Avslutt bruk av erfaringen",
        editLesson: "Endre erfaring",
        confirmDelete: "Vil du slette denne erfaringen?"
      },
      keywords: {
        title: "Og inneholder nøkkelord",
        description: "Nøkkelord adskilt med komma (,)"
      },
      filterOptions: {
        time: {
          options: {
            lessThan12Months: "Nyere enn 12 måneder",
            oneToThreeYears: "Mellom 1 og 3 år",
            threeToFiveYears: "Mellom 3 og 5 år",
            moreThanFiveYears: "Eldre enn 5 år"
          }
        }
      }
    },
    currency: "Valuta for dette prosjektet er {currency}. Du kan endre prosjektets valuta i ",
    projectPropertiesLink: "Prosjektegenskaper",
    stagePlanCurrency: "Kostnad er vist i {currency}.",
    actuals: "Faktiske verdier",
    showingActuals: "Faktiske verdier er registrert",
    projectIsCompleted: "Prosjektet er avsluttet",
    closureInProgress: "Prosjektavslutning pågår",
    phaseTransition: {
      stageOutsidePhases: "Det er etappe(r) utenfor fasene. Faseovergang er derfor ikke mulig",
      requestToStart: "Forespør oppstart av",
      projectNotStarted: "Prosjektet er ikke startet",
      requestComments: "Kommentarerer til forespørselen",
      readMore: "Les mer om",
      cancel: "Avbryt",
      submitRequest: "Send forespørsel",
      requestPending: "Venter på godkjenning til å starte",
      retractRequest: "Trekk tilbake forespørselen",
      approveRequest: "Godkjenn forespørsel",
      currentPhase: "Gjeldende fase",
      requestToEnd: "Forespørsel om avslutning av",
      prepareClosure: "Forbered prosjektavslutning"
    },
    exceptionPlan: {
      title: "Unntaksplan",
      readMore: "Se detaljer...",
      approve: "Godkjenn unntaksplan",
      exceptionReport: "Unntaksrapport",
      baselinePlan: "Godkjent plan",
      beforeExceptionAproval: "før godkjenning av unntak",
      afterExceptionApproval: "etter godkjenning av unntak",
      stageNotFound: "<etappe er ikke funnet>",
      update: "Oppdater",
      requestApproval: "Forespør godkjenning",
      cancel: "Avbryt",
      missingExceptionReport: "Referanse til unntaksplan mangler.",
      newBaselinePlan: "Ny godkjent plan",
      fields: {
        summary: {
          title: "Oppsummering av unntaksplanen",
          help: "Hva skyldes avviken fra avtalt plan? Hva er konsekvensene? Hva er hovedforskjellen mellom unntaksplanen og siste godkjente plan?",
          description: "Oppsummer årsak og konsekvenser av unntaket, hvordan unntaksplanen avviker fra godkjent plan."
        },
        level: {
          title: "Unntaksnivå",
          options: {
            stage: { title: "Etappe" },
            phase: { title: "Fase" },
            project: { title: "Prosjekt" }
          }
        },
        report: {
          title: "Unntaksrapport",
          empty: "-- velg unntaksrapport --"
        }
      }
    },
    baselineHistory: {
      title: "Godkjenningshistorikk",
      close: "Lukk historikk",
      hideDetails: "Skjul detaljer",
      header: {
        approvedPID: "Godkjent styringsdoukment",
        approvedStage: "Godkjent etappe",
        unknown: "ukjent godkjenning",
        exception: {
          stage: "Unntak for etappe",
          phase: "Unntak for fase",
          project: "Unntak for prosjekt",
          unknown: "Ukjent unntak"
        }
      },
      noBaseline: "Prosjektet har ikke godkjenningshistorikk. Historikken oppstår når styringsdokumentet eller en etappeplan godkjennes.",
      loadingHistory: "Laster historikk...",
      errorOccuredDurligLoading: "En feil oppstov ed lasting av historikk",
      entry: {
        approvedPID: "Godkjent styringsdokument",
        baselinePlan: "Godkjent plan",
        newBaselinePlan: "Ny godkjent plan",
        beforePIDApproval: "før styringsdokumentet ble godkjent",
        afterPIDApproval: "etter at styringsdokumentet ble godkjent",
        approvedStagePlan: "Godkjent etappeplan",
        beforeStageApproval: "før etappeplanen ble godkjent",
        afterStageApproval: "etter at etappeplanen ble godkjent",
        unknownBaseline: "Ukjent type godkjent plan"
      }
    }
  },
  planApproach: {
    title: "Tilnærming",
    description: "Prosjekttilnærmingen beskriver hvordan prosjektet vil gjennomføre arbeidet. Tilnærmingen skal forklare hvilke arbeidsmetoder som skal brukes, hvordan prosjekt skal bemannes, tekniske og regulatoriske strategier og andre relevante aspekter som påvirker organiseringen og gjennomføringen av prosjektet.",
    fields: {
      methods: {
        title: "Metoder",
        help: `Skal det gjøres tilpassninger til prosjektmetoden? Hva blir skalert ned eller ikke brukt, og hvorfor?
          Hvilken spesifikk metodikk og teknisk metode skal brukes?
          Vil det blir gjort avvik fra standard operasjonsprosedyrer eller retningslinjer?
          Vil dette prosjektet gå gjennom et sett av definerte livssyklusfaser?
          Er det retningslinjer eller standard praksis som skal brukes?`,
        description: "Beskriv i hvilken grad prosjektmetoden er skreddersydd og bruk av spesialist-, utvikling-, og/eller produksjonsmetoder eller prosesser"
      },
      resources: {
        title: "Ressurser",
        help: `Utføres arbeidet av eller i samarbeid med partnere? Hvis ja, hvem vil gjøre hva?
          Skal det bruke interne og/eller eksterne ressurser? Hvis ja, hvem vil gjøre hva?
          Hvordan skal ressursbruken finansieres? Vil det bli løs eller streng oppfølging av ressursbruken?`,
        description: "Beskriv hvordan vi får de nødvendige personene, utstyr og penger for å få prosjektet gjennomført."
      },
      technology: {
        title: "Tekologi",
        help: `Skal det brukes en spesifikk teknologi, eller hvordan skal teknologiplattformen velges?
          Vil det bli bygget på hyllevare eller være skreddersøm?
          Er det snakk om et spesifikk produksjonssted eller metode som er valgt, eller hvordan vil det bli valgt?
          Er det valgt reguleringsstrategi, eller hvordan vil den bli valgt?`,
        description: "Beskriv teknologien som skal brukes eller bygges videre på, og reguleringsstrategien som er relevant for den valgte teknologien."
      },
      rollOut: {
        title: "Utrullingsstrategi",
        help: `Er dette en midlertidig "dekke-gap" eller "evigvarende" løsning?
          Hvordan tilgjengeliggjøres forskjellige versjoner/utgivelser? Er det planlagt fremtidige oppdateringer? Hvor skal produktene rulles ut, distribueres eller gjøres tilgjengelig først og sist?
          Skal kunngjøringer til mottakerne, brukerne og markedet gjøres sent eller tidlig, og hvorfor?`,
        description: "Beskriv lansering, utrulling eller distribusjonsstrategi av sluttproduktet."
      },
      other: {
        title: "Annet",
        description: "Er det noe annet som bør nevnes i forhold til hvordan arbeidet i prosjektet vil tilnærmes?"
      }
    }
  },
  schedule: {
    title: "Tidsplan",
    fields: {
      schedule: {
        columnHeaders: {
          stage: {title: "Etappe"},
          time: {title: "Tid"},
          cost: {title: "Kostnad"}
        },
        columns: {
          name: { title:""},
          start: { title:"Start" },
          end: { title: "Slutt" },
          timeTolerance: { title: "Toleranse" },
          hours: { title: "Timer" },
          expences: { title: "Utgifter" },
          investments: { title: "Investeringer" },
          sum: { title: "Sum" },
          costTolerance: { title: "Toleranse" }
        },
        options: {
          addEntry: { title: "+ Legg til etappe" }
        }
      }
    }
  },
  lessons: {
    title: "Erfaringer",
    fields: {
      lessonLog: {
        title:"Opplevde erfaringer",
        columns: {
          no: { title:"Id" },
          title: { title: "Tittel" },
          source: { title: "Kilde" },
          priorityLabel: { title: "Prioritet" },
          recommendations: { title:"Anbefalinger" }
        },
        options: {
          addEntry: {
            title: "Legg til erfaring"
          }
        }
      }
    }
  },
  summary: {
    title: "Oppsummering",
    fields: {
      title: {
        title: "Tittel",
        help: `Kort oppsummering av det som er erfart`,
        description: "Oppsummer erfaringen"
      },
      type: {
        title: "Relevant for",
        options: {
          project: "Kun prosjektet",
          program: "Alle prosjekter i programmet",
          portfolio: "Alle prosjekter i porteføljen",
          corporate: "Alle prosjekter"
        }
      },
      priority: {
        title: "Prioritet",
        help: `Hvis denne erfaringen ignoreres senere i prosjektet eller i andre prosjekter, hvor vesentlig vil effekten være på prosjektets mål?`,
        options: {
          high: "Høy",
          medium: "Middels",
          low: "Lav"
        }
      }
    }
  },
  detail: {
    title: "Detaljer",
    fields: {
      cause: {
        title: "Årsak",
        help: `Hva utløste hendelsen? Hva var situasjonen som ga opphav til erfaringen. Eksempel: Teknisk kravdokumentasjon var ikke fullført`,
        description: "Beskriv årsaken til at hendelsen oppstod"
      },
      event: {
        title: "Hendelse",
        help: `Hvilken begivenhet ble utløst av årsaken. Eksempel: Det tekniske designarbeidet kunne ikke starte`,
        description: "Beskriv hva som skjedde"
      },
      effect: {
        title: "Effekt",
        help: `Hva var effekten, og hvilke konsekvenser medførte dette for prosjektets mål? Eksempel: Prosjektet ble forsinket med to måneder`,
        description: "Beskriv påvirkningen på prosjektmålene (tid, kostnad, kvalitet, omfang, gevinst, risiko)"
      },
      description: {
        title: "Detaljert beskrivelse",
        description: "Beskriv relevant bakgrunn, sammenheng og fakta relatert til erfaringen",
        help: `Hvilken informasjon er relevant for noen som vurderer å bruke denne erfaringen? Er det nødvendig med ytterligere bakgrunn eller sammenheng? Finnes det noe kvantifisert statistikk, målinger eller fakta relatert til denne erfaringen?`
      }
    }
  },
  followUp: {
    title: "Oppfølging",
    fields: {
      indicators: {
        title: "Tidlige varselsindikatorer",
        help:`Hvilke situasjoner bør brukes til å fokusere oppmerksomhet på dette området i fremtiden?
          Under hvilke omstendigheter skal denne erfaringen brukes for å unngå negativ innvirkning på prosjektet?
          Var dette tidligere identifisert som en risiko?`,
        description: "Beskriv hvordan samme eller lignende hendelser kan varsles på forhånd"
      },
      recommendations: {
        title: "Anbefalinger",
        help: `Hvis disse omstendighetene (de tidlige varslingsindikatorene) skulle dukke opp igjen, hva er da viktig å gjøre?
          Hva er ditt råd for fremtiden?`,
        description: "Oppsummer hva som bør gjøres fremover"
      }
    }
  },
  projectControls: {
    title: "Prosjektkontroll",
    description: "Prosjektkontroll definerer hvordan styringsgruppen får tilfredsstillende kontroll med prosjektet og hvordan prosjektlederen sikrer tilstrekkelig kontroll med arbeidet gjort i prosjektet.",
    fields: {
      projectControls: {
        title: "Prosjektkontroll",
        help: `Hva er frekvens og format for kommunikasjon mellom prosjektleder og prosjektstyret (styringsgruppen)?
          Hva er frekvensen og format for kommunikasjon mellom teamleder og prosjektleder?
          Finnes det noen retningslinjer/anbefalringer på lengden av etappene? Korte etapper gir mer kontroll, men også merarbeid.
          Når skal det eskaleres til informasjon, til beslutning eller for å be om veiledning? Når skal "flagget heves"?
          Hvilke verktøy og prosesser brukes for eskalering til informasjon, til beslutning eller for å be om veiledning?`,
        description: "Beskriv nødvendige kontroller på prosjektnivå, for eksempel overvåkning, eskalering og rapporteringsformat og frekvens"
      }
    }
  },
  stageDescription: {
    frontPage: "Forside",
    title: "Etappe",
    fields: {
      identifier: {
        title: 'Identifikator',
        description: '(ikke i bruk)'
      },
      name: {
        title: "Navn",
        description: "Angi en kort tittel på etappen"
      },
      description: {
        title: "Beskrivelse av etappen",
        help: `Hvor i prosjektets livssyklus er denne etappen og hvilket type arbeid er gjort (analyse, design, test, etc)?
          Hva er målet med etappen?
          Kort oppsummert, hva vil denne etappen inneholde og hvordan vil det bli gjort?
          `,
        description: "Beskriv kort hva denne etappen innebærer"
      },
      prerequisite: {
        title: "Forutsetning for etappen",
        help:`Er det eksisterende dokumentasjon eller annen informasjon denne planen har blitt laget på bakgrunn av eller trenger for å kunne starte?
          Er det noen leveranser, hendelser eller beslutninger som må utføres for at denne etappen kan begynne?`,
        description: "Beskriv hva som må være på plass for at etappen kan starte"
      },
      method: {
        title: "Metode",
        values: {
          product: "Produktledelse",
          project: "Prosjektledelse"
        }
      }
    }
  },
  stageContext: {
    title: "Tilnærming",
    fields: {
      externalDependencies: {
        title: "Eksterne avhengigheter",
        help: `Er det aktiviteter utenfor dette prosjektet som kan påvirke gjennomføring av etappen?
          Er du avhengig av leveranse fra andre prosjekter eller at ressurser andre prosjekter frigjøres for å gjennomføre etappen?
          Er det handlinger, hendelser eller beslutninger utenfor prosjektet som påvirker gjennomføring av etappen?`,
        description: "Beskriv eksterne avhengigheter"
      },
      assumptions: {
        title: "Antagelser i planleggingen",
        help: `Er det noen antagelser om tilgang til ressurser, verktøy eller kompetanse?
          Er det gjort antagelser om grad av ferdigstilling på påkrevde elementer for etappen?`,
        description: "Beskriv antagelsene som er gjort i planleggingen"
      },
      stageApproach: {
        title: "Tilnærming for etappen",
        help: `Skal en spesifikk metodikk eller teknisk metode brukes i dette etappen?
          Er det retningslinjer eller standard praksis som skal brukes?
          Vil det blir brukt interne eller eksterne team, eller begge deler? Hvis ja, hvem skal gjøre hva?
          Brukes det spesifikk teknologi i denne etappen?`,
        description: "Beskriv tilnærming for etappen"
      },
      lessonsIncorporated: {
        title: "Erfaringer som er brukt",
        help: `Er relevante erfaringer fra tidligere brukt i planleggingen av denne etappen?
          Er relevante erfaringer fra andre prosjekter brukt i planleggingen av denne etappen?`,
        description: "Beskriv relevante erfaringer som er brukt i planleggingen og for gjennomførting av etappen"
      },
      monitorAndControl: {
        title: "Overvåkning og styring",
        help: `Hva er frekvensen og formatet for kommunikasjonen mellom prosjektleder og prosjektstyret i etappen?
          Hva er frekvensen og formatet for kommunikasjon mellom teamleder og prosjektleder?
          Når vil noe blie eskalert for informasjon, til beslutning eller for veiledning? Når vil ett flagg bli hevet?
          Hvilke verktøy og prosesser brukes til å eskalere informasjon, beslutninger eller veiledning?`,
        description: "Beskriv kontrollmekanismene for etappen, f.eks overvåkning, eskalering og rapporteringsformater og -frekvens"
      }
    }
  },
  stageTime: {
    title: "Tid",
    fields: {
      period: {
        title: "Etappens periode"
      },
      timeTolerance: {
        title: "Tidstoleranse (verdi)",
        description: "I arbeidsdager, arbeidsuker eller måneder"
      },
      timeToleranceUnit: {
        title: "Tidstoleranse (enhet)",
        options: {
          days: "Dager",
          weeks: "Uker",
          months: "Måneder"
        }
      },
      timeToleranceComment: {
        title:"Tidstoleranse kommentar"
      },
      timeComments: {
        title: "Kommentarer til tid",
        description: "Kommentarer til tidsaspektet av etappen"
      }
    }
  },
  stageCost: {
    title: "Kostnad",
    fields: {
      budget: {
        title: "Etappens budsjett",
        help: `Timer: Antall timer som trengs av internt personale, eller timer brukt av eksterne ressurser hvor tilnærmingen er å følge opp prosjektkostnaden i timer.
          Utgifter: Direkte utgifter mottatt som faktura. Dette bør normalt utelukke utgifter ført som timer. Bør ikke inkludere investeringer.
          Investeringer: Balanseførte kostnader for anleggsmidler
          Totalt: Manuelt beregnet total kostnad for etappen. Vanligvis totalt = timer x timekostnad + utgifter + investeringer.`,
        columns: {
          element: { title: "Kostnadselement" },
          cost: { title: "Kostnad" },
          tolerance: { title: "Toleranse" },
          comment: { title: "Kommentar" }
        },
        samples: [
          { element: "Timer" },
          { element: "Utgifter" },
          { element: "Investeringer" }
        ]
      }
    }
  },
  stageScheduleScope: {
    title: "Fremdriftsplan og omfang",
    fields: {
      plan: {
        title: "Fremdriftsplan",
        columns: {
          workPackage: { title: "Arbeidspakke" },
          owner: { title: "Eier" },
          dueDate: { title: "Tidsfrist" },
          status: { title: "Status" },
          comment: { title: "Kommentar" }
        },
        samples: [
          { workPackage: "Pilot A\n  - Prototype A\n  - Rapport fra pilot", owner: "IT-lederen", dueDate: "2018-12-01", status: "Ferdig" },
          { workPackage: "Markedsføring\n  - Produkwebside\n  - Lanseringsplan", owner: "Markedsføringsdirektøren", dueDate: "2018-12-12", status: "Påbegynt" },
          { workPackage: "Rydding", owner: "Donald Duck", dueDate: "2018-11-20", status: "Ikke påbegynt" }
        ],
        options: {
          addEntry: { title: "+Legg til" }
        }
      },
      scheduleComments: {
        title: "Planlagte leveranser",
        description: "Beskriv eller list opp hva som vil bli levert i dennne etappen, når og av hvem"
      }
    }
  },
  actuals: {
    title:"Faktisk utførelse",
    fields: {
      period: {
        title: "Faktisk periode for etappen"
      },
      cost: {
        title: "Faktiske kostnader for etappen",
        columns: {
          element: { title: "Kostnadselement" },
          cost: { title: "Kostnad" },
          comment: { title: "Kommentar" }
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/plan/labels/norwegian.js